import Any from "./Any"

export default class Shape extends Any {
  constructor(properties) {
    super()

    this.type = `object`
    this.format = `shape`

    if (typeof properties !== `object`) {
      throw new TypeError(`Expects Shape properties to be object`)
    }

    this.properties = {
      ...properties,
    }
  }
}
